import React from 'react';
import { styled, Box, Typography, LinearProgress } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import theme from '../../../../../styles/theme';

export const Body = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '257px',
  boxSizing: 'border-box' as any,
  padding: '0px 10px',
  gap: '6px',
});

export const GoalItem = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.colors.background,
  padding: '8px 14px',
  borderRadius: '12px',
  width: '100%',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: '#1a1c38',
  },
});

export const GoalHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '5px',
});

export const Title = styled(Typography)({
  fontSize: '15px',
  fontWeight: 600,
  color: '#ffffffdd',
  letterSpacing: '0.3px',
});

export const PercentText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 700,
  letterSpacing: '0.5px',
});

export const MoneyProgress = styled(Typography)({
  fontSize: '12px',
  color: '#ffffff88',
  marginTop: '4px',
});

export const BarProgress = styled(Box)({
  position: 'relative',
  width: '100%',
});

export function Progress(props: any) {
  const { color, value, achieved } = props;

  const useStyles = makeStyles({
    bar: {
      backgroundColor: color,
      ...(achieved && {
        boxShadow: `0 0 8px ${color}66`,
      }),
    },
  });
  const classes = useStyles();
  return (
    <BasicProgress
      variant="determinate"
      value={value}
      classes={{ bar: classes.bar }}
    />
  );
}

export const BasicProgress = withStyles({
  root: {
    height: 8,
    backgroundColor: theme.colors.backgroundLight,
    width: '100%',
    borderRadius: 4,
  },
  bar: {
    borderRadius: 4,
    transition: 'width 0.6s ease',
  },
})(LinearProgress);
